import { render, staticRenderFns } from "./Fox.vue?vue&type=template&id=13e80514&"
import script from "./Fox.vue?vue&type=script&lang=js&"
export * from "./Fox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports